<script>
    import jQuery from "jquery";
    import {getGPTransFunc} from "./gp-translations.js";
    import {GPMisc} from "./gp-misc";
    import {season} from "./gp";
    let trans = getGPTransFunc("gp-bloomtable");

    export let project;


   export function open() {
        jQuery('#GPBloomTable').modal({});
        jQuery('#GPBloomTable').on('hidden.bs.modal', () => this.$destroy());
   }

   function selectItems(item) {
       GP.selectItemsByType(item)
   }

   function selectMonth(month) {
        if (!GPSettings.products["four_seasons"].active) return GPSettings.upgradeClass.showOnlyInPremium("seasons");
        $season = month;
   }

</script>


<div class="modal fade GPModal" tabindex="-1" id="GPBloomTable">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                <h4 class="modal-title">{trans("Bloom times for plants in this project")}</h4>
            </div>
            <div class="modal-body">
                <div class="form-group">
                    <table>
                        <tr>
                            <th>
                            </th>
                            <th>
                                {trans("Months")}
                            </th>
                        </tr>
                        <tr>
                            <td> </td>
                            <td>
                                <div class="GPBlossomGauge">
                                    {#each [1,2,3,4,5,6,7,8,9,10,11,12] as month}
                                    <a on:click={() => selectMonth(month)} class="GPBlossomGaugeBlock">{GPMisc.roman[month-1]}</a>
                                    {/each}
                                </div>
                            </td>
                        </tr>
                        {#each project.plantTypes() as item}
                            {#if item.data.blossom_to && item.data.blossom_from}
                                <tr>
                                    <td><a on:click={() => selectItems(item)}>{item.name}</a></td>
                                    <td>
                                        <div class="GPBlossomGauge">
                                            {#each [1,2,3,4,5,6,7,8,9,10,11,12] as month}
                                                <div class="GPBlossomGaugeBlock" class:active={item.data.blossom_to && item.data.blossom_from && item.data.blossom_to >= month && item.data.blossom_from <= month}></div>
                                            {/each}
                                        </div>
                                    </td>
                                </tr>
                            {/if}
                        {/each}
                    </table>
                </div>
            </div>
        </div><!-- /.modal-content -->
    </div><!-- /.modal-dialog -->
</div><!-- /.modal -->